module.exports = __webpack_public_path__ + "img/mercedes-benz-g-2022.76d34701.jpg";